(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["album-image-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var TARGET_FALLBACKS = [
      '[data-apg-target] img', '[data-apg-target]',
      '.product-media-container img', 'product-media-gallery img',
      '.product__media img', '.product-media img', '.product__media-item img'
    ];

    function targetImg(root){
      var sel = root.getAttribute('data-target');
      var list = (sel ? [sel] : []).concat(TARGET_FALLBACKS);
      for (var i = 0; i < list.length; i++){
        var el = null;
        try { el = document.querySelector(list[i]); } catch (e) {}
        if (el) return el;
      }
      return null;
    }

    // The /cart/add fetch override is installed by the early inline <script> at the
    // top of this block. Here we just publish the current pick's line item
    // properties to that shared global for the override to read.
    window.__apgCart = window.__apgCart || { selection: null };

    function init(root){
      /* Liquid is not rendered inside a block's javascript tag, so these ride
         in as data attributes on the root element, which is rendered. */
      var I18N = {
        notConfigured: root.getAttribute('data-i18n-not-configured') || '',
        searching: root.getAttribute('data-i18n-searching') || '',
        searchFailed: root.getAttribute('data-i18n-search-failed') || '',
        noMatches: root.getAttribute('data-i18n-no-matches') || '',
        untitled: root.getAttribute('data-i18n-untitled') || '',
      };
      if (root.hasAttribute('data-apg-init')) return;
      root.setAttribute('data-apg-init', '1');

      var API = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
      var searchbox = root.querySelector('.apg__searchbox');
      var form = root.querySelector('[data-form]');
      var input = root.querySelector('[data-input]');
      var results = root.querySelector('[data-results]');
      var status = root.querySelector('[data-status]');
      var context = root.querySelector('[data-context]');

      var overlay = null, currentItem = null;
      var selectedUrl = null, watching = false, watchTimer = null;

      function setStatus(m){ status.hidden = !m; status.textContent = m || ''; }

      function previewUrl(item){
        return API + '/api/v1/preview?source=' + encodeURIComponent(item.source || 'spotify') +
               '&id=' + encodeURIComponent(item.id);
      }

      function setContext(item){
        if (!item){ context.hidden = true; context.textContent = ''; return; }
        context.hidden = false;
        context.innerHTML =
          '<span class="apg__ctx-title"></span> <span class="apg__ctx-hint"></span>';
        context.querySelector('.apg__ctx-title').textContent =
          (item.name || '') + (item.artist ? ' — ' + item.artist : '');
        context.querySelector('.apg__ctx-hint').textContent = 'set as your product image';
      }

      function productLoading(on){
        var img = targetImg(root);
        if (!img) return;
        var host = img.parentElement || img;
        if (on){
          if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
          if (!overlay){ overlay = document.createElement('div'); overlay.className = 'apg__overlay'; overlay.innerHTML = '<span class="apg__spin"></span>'; }
          host.appendChild(overlay);
        } else if (overlay && overlay.parentNode){
          overlay.parentNode.removeChild(overlay);
        }
      }

      // Re-apply the picked poster if the theme swaps the product media back (it does
      // this on variant change), so the selection sticks across size/variant changes.
      function reapplySelected(){
        if (!selectedUrl) return;
        var img = targetImg(root);
        if (img && img.getAttribute('src') !== selectedUrl){
          img.removeAttribute('srcset');
          img.setAttribute('src', selectedUrl);
        }
      }
      function ensureMediaWatch(){
        if (watching) return;
        var img = targetImg(root);
        if (!img) return;
        var container = img.closest('.shopify-section, .product, product-info, main') || img.parentElement;
        if (!container) return;
        watching = true;
        var mo = new MutationObserver(function(){
          if (!selectedUrl) return;
          clearTimeout(watchTimer);
          watchTimer = setTimeout(reapplySelected, 60);
        });
        mo.observe(container, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
        var pf = productForm();
        if (pf) pf.addEventListener('change', function(){ clearTimeout(watchTimer); watchTimer = setTimeout(reapplySelected, 150); });
      }

      function setProductImage(url){
        var img = targetImg(root);
        if (!img) return false;
        selectedUrl = url;
        ensureMediaWatch();
        img.removeAttribute('srcset');
        if (img.getAttribute('src') === url && img.complete) return true;
        // Show the spinner until the newly selected image finishes loading
        // (the watermarked image is generated server-side, so it takes a moment).
        productLoading(true);
        var done = function(){
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          productLoading(false);
        };
        img.addEventListener('load', done);
        img.addEventListener('error', done);
        img.setAttribute('src', url);
        return true;
      }

      // Attach the selection to the ordered product via line item properties.
      // Names start with "_" so they're hidden from the customer in cart/checkout
      // but still recorded on the order (visible in the Shopify admin).
      function productForm(){
        var scope = root.closest('.shopify-section, product-form, .product') || document;
        return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      }
      function setProp(pf, key, value){
        var el = pf.querySelector('input[data-apg-prop="' + key + '"]');
        if (!el){
          el = document.createElement('input');
          el.type = 'hidden';
          el.setAttribute('data-apg-prop', key);
          el.name = 'properties[' + key + ']';
          pf.appendChild(el);
        }
        el.value = value == null ? '' : value;
      }
      function writeLineItemProps(item){
        var pf = productForm();
        if (!pf || !item) return;
        setProp(pf, '_Album', item.name || '');
        setProp(pf, '_Artist', item.artist || '');
        setProp(pf, '_Year', item.year || '');
        setProp(pf, '_Source', item.source || '');    // spotify / itunes
        setProp(pf, '_Album ID', item.id || '');       // id used to regenerate the print
        setProp(pf, '_Preview URL', previewUrl(item));
      }

      function doSearch(q){
        if (!q) return;
        if (!API){ results.hidden = false; results.innerHTML = '<div class="apg__error">' + I18N.notConfigured + '</div>'; return; }
        results.hidden = false; results.innerHTML = '<div class="apg__muted">' + I18N.searching + '</div>';
        setStatus('');
        fetch(API + '/api/v1/search?q=' + encodeURIComponent(q))
          .then(function(r){ if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
          .then(function(data){ renderResults((data.results || []), (data.source || 'spotify')); })
          .catch(function(){ results.innerHTML = '<div class="apg__error">' + I18N.searchFailed + '</div>'; });
      }

      function renderResults(list, fallbackSource){
        results.innerHTML = '';
        if (!list.length){ results.innerHTML = '<div class="apg__empty">' + I18N.noMatches + '</div>'; return; }
        list.forEach(function(item){
          if (!item.source) item.source = fallbackSource;
          var el = document.createElement('button');
          el.type = 'button'; el.className = 'apg__result'; el.setAttribute('role', 'option');
          var poster = document.createElement('span');
          poster.className = 'apg__result-poster';
          if (item.image) poster.style.backgroundImage = 'url("' + item.image + '")';
          var body = document.createElement('span'); body.className = 'apg__result-body';
          var title = document.createElement('span'); title.className = 'apg__result-title'; title.textContent = item.name || I18N.untitled;
          var sub = document.createElement('span'); sub.className = 'apg__result-sub';
          sub.textContent = [item.artist, item.year].filter(Boolean).join(' · ');
          body.appendChild(title); body.appendChild(sub);
          el.appendChild(poster); el.appendChild(body);
          el.addEventListener('click', function(){ selectItem(item); });
          results.appendChild(el);
        });
      }

      function selectItem(item){
        currentItem = item;
        results.hidden = true;
        setStatus('');
        setContext(item);
        // Swap the product image to this album's framed, watermarked preview.
        setProductImage(previewUrl(item));
        // Record the pick on the order.
        window.__apgCart.selection = {
          '_Album': item.name || '',
          '_Artist': item.artist || '',
          '_Year': item.year || '',
          '_Source': item.source || '',
          '_Album ID': item.id || '',
          '_Preview URL': previewUrl(item)
        };
        writeLineItemProps(item);
        // Scroll up so the customer sees the product image update.
        var img = targetImg(root) || root;
        if (img && img.scrollIntoView) img.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      form.addEventListener('submit', function(e){ e.preventDefault(); doSearch(input.value.trim()); });

      // Close the results dropdown when clicking outside the search box.
      document.addEventListener('click', function(e){
        if (searchbox && !searchbox.contains(e.target)) results.hidden = true;
      });
    }

    function initAll(){ document.querySelectorAll('[data-apg]').forEach(init); }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pinterest-image-search"] && !Shopify.designMode) return;
  try {
    (function () {
    var TARGET_FALLBACKS = [
      '[data-fpp-target] img', '[data-fpp-target]',
      '[data-fpi-target] img', '[data-fpi-target]',
      '.product-media-container img', 'product-media-gallery img',
      '.product__media img', '.product-media img', '.product__media-item img'
    ];

    function targetImg(root){
      var sel = root.getAttribute('data-target');
      var list = (sel ? [sel] : []).concat(TARGET_FALLBACKS);
      for (var i = 0; i < list.length; i++){
        var el = null;
        try { el = document.querySelector(list[i]); } catch (e) {}
        if (el) return el;
      }
      return null;
    }

    // The /cart/add fetch override is installed by the early inline <script> at the
    // top of this block. Here we just publish the current pick's line item
    // properties to that shared global for the override to read.
    window.__fpiCart = window.__fpiCart || { selection: null };

    function init(root){
      /* Liquid is not rendered inside a block's javascript tag, so these ride
         in as data attributes on the root element, which is rendered. */
      var I18N = {
        tapHint: root.getAttribute('data-i18n-tap-hint') || '',
        notConfigured: root.getAttribute('data-i18n-not-configured') || '',
        propPoster: root.getAttribute('data-i18n-prop-poster') || 'Poster',
      };
      if (root.hasAttribute('data-fpp-init')) return;
      root.setAttribute('data-fpp-init', '1');

      var API = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
      var form = root.querySelector('[data-form]');
      var input = root.querySelector('[data-input]');
      var gallery = root.querySelector('[data-gallery]');
      var grid = root.querySelector('[data-grid]');
      var moreBtn = root.querySelector('[data-more]');
      var lessBtn = root.querySelector('[data-less]');
      var status = root.querySelector('[data-status]');
      var context = root.querySelector('[data-context]');

      var all = [], shown = 0, overlay = null;
      var query = '', bookmark = null, loading = false, exhausted = false;
      var selectedId = null, selectedUrl = null, watching = false, watchTimer = null;
      // Set when the customer already picked an image in the store search and
      // landed here with it in the URL — see the prefill block at the bottom.
      var seededPin = null;
      // The exact query the store search sent to the API — for the arrival search
      // we reuse their string verbatim and land on an identical list.
      var sentOverride = null;
      var INITIAL = 4; // Images shown as soon as a search returns — one full row on
                       // mobile, no wrap. No dropdown, no "pick a title" step: the
                       // results ARE the gallery.
      var STEP = 10;   // "Show more" reveals this many additional images per click

      // Lazy-load tile backgrounds as they scroll into view, so opening a 100-image
      // buffer doesn't fire 100 requests at once. The grid itself doesn't scroll (the
      // page does), so the observer root is the viewport.
      var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          var t = e.target, u = t.getAttribute('data-bg');
          if (u){ t.style.backgroundImage = 'url("' + u + '")'; t.removeAttribute('data-bg'); }
          io.unobserve(t);
        });
      }, { rootMargin: '400px 0px' }) : null;

      function setStatus(m){ status.hidden = !m; status.textContent = m || ''; }

      function setContext(q, count){
        if (!q){ context.hidden = true; context.textContent = ''; return; }
        context.hidden = false;
        context.innerHTML =
          '<div class="fpp__ctx-main"><span class="fpp__ctx-title"></span><span class="fpp__ctx-count"></span></div>' +
          '<div class="fpp__ctx-hint">' + I18N.tapHint + '</div>';
        context.querySelector('.fpp__ctx-title').textContent = q;
        context.querySelector('.fpp__ctx-count').textContent =
          (count == null) ? 'Loading…' : (count + (count === 1 ? ' image' : ' images'));
      }

      function showSkeletons(){
        grid.innerHTML = '';
        for (var i = 0; i < INITIAL; i++){ var s = document.createElement('div'); s.className = 'fpp__thumb fpp__skel'; grid.appendChild(s); }
        moreBtn.hidden = true;
        if (lessBtn) lessBtn.hidden = true;
      }

      function productLoading(on){
        var img = targetImg(root);
        if (!img) return;
        var host = img.parentElement || img;
        if (on){
          if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
          if (!overlay){ overlay = document.createElement('div'); overlay.className = 'fpp__overlay'; overlay.innerHTML = '<span class="fpp__spin"></span>'; }
          host.appendChild(overlay);
        } else if (overlay && overlay.parentNode){
          overlay.parentNode.removeChild(overlay);
        }
      }

      // Re-apply the picked image if the theme swaps the product media back (it does
      // this on variant change), so the selection sticks across size/variant changes.
      function reapplySelected(){
        if (!selectedUrl) return;
        var img = targetImg(root);
        if (img && img.getAttribute('src') !== selectedUrl){
          img.removeAttribute('srcset');
          img.setAttribute('src', selectedUrl);
        }
      }
      function ensureMediaWatch(){
        if (watching) return;
        var img = targetImg(root);
        if (!img) return;
        var container = img.closest('.shopify-section, .product, product-info, main') || img.parentElement;
        if (!container) return;
        watching = true;
        var mo = new MutationObserver(function(){
          if (!selectedUrl) return;
          clearTimeout(watchTimer);
          watchTimer = setTimeout(reapplySelected, 60);
        });
        mo.observe(container, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
        var f = productForm();
        if (f) f.addEventListener('change', function(){ clearTimeout(watchTimer); watchTimer = setTimeout(reapplySelected, 150); });
      }

      function setProductImage(url){
        var img = targetImg(root);
        if (!img) return false;
        selectedUrl = url;
        ensureMediaWatch();
        img.removeAttribute('srcset');
        if (img.getAttribute('src') === url && img.complete) return true;
        productLoading(true);
        var done = function(){
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          productLoading(false);
        };
        img.addEventListener('load', done);
        img.addEventListener('error', done);
        img.setAttribute('src', url);
        return true;
      }

      // Attach the selection to the ordered product via line item properties.
      // Names start with "_" so they're hidden from the customer in cart/checkout
      // but still recorded on the order (visible in the Shopify admin).
      function productForm(){
        var scope = root.closest('.shopify-section, product-form, .product') || document;
        return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      }
      function setProp(f, key, value){
        var el = f.querySelector('input[data-fpp-prop="' + key + '"]');
        if (!el){
          el = document.createElement('input');
          el.type = 'hidden';
          el.setAttribute('data-fpp-prop', key);
          el.name = 'properties[' + key + ']';
          f.appendChild(el);
        }
        el.value = value == null ? '' : value;
      }
      // The order carries the HIGH-QUALITY link (im.hq) — open it from the Shopify
      // admin to get the exact original to print. The customer only ever saw the
      // mid-quality preview.
      // _Image Ref is that same image as a bare id. The URL is signed with PIN_SECRET,
      // so rotating the secret would 403 every link already sitting on past orders;
      // the ref survives that and lets you rebuild the link. Same self-describing
      // order data the movie product gets from _Media ID + _Image ID.
      // _Image Preview is the framed mid-quality render the customer actually saw —
      // the cart renders it as the line's thumbnail, so it must stay small. It is
      // the preview only: _Image URL stays the bare high-quality original, since
      // that is the file you print and it must not carry a mock frame.
      // The one VISIBLE property: the search name. Shopify drops "_" properties from
      // checkout and the order emails, so without it the customer sees a bare
      // "Find your poster" there. The email template pairs it with _Image Preview.
      function selectionFor(im){
        var sel = {};
        sel[I18N.propPoster] = query;
        return Object.assign(sel, {
          '_Source': 'Pinterest',
          '_Title': im.title || query,
          '_Search': query,
          '_Image ID': im.id || '',
          '_Image Ref': im.ref || '',
          '_Size': (im.width && im.height) ? (im.width + ' x ' + im.height) : '',
          '_Image URL': im.hq || im.image || '',
          '_Image Preview': im.framed || im.image || im.thumb || ''
        });
      }
      function writeLineItemProps(im){
        var f = productForm();
        if (!f) return;
        var sel = selectionFor(im);
        for (var k in sel) setProp(f, k, sel[k]);
      }

      // One page of results. Page 1 resets; later pages append using the cursor the
      // API handed back. The query goes out exactly as typed — the API appends
      // its poster suffix server-side.
      function fetchPage(reset){
        if (loading) return Promise.resolve();
        loading = true;
        var sent = sentOverride || query;
        var qs = '/api/pin/search?query=' + encodeURIComponent(sent);
        // When an arrival search reuses the store search's string, tell analytics
        // what was typed on this page rather than the reused query.
        if (sent !== query) qs += '&raw=' + encodeURIComponent(query);
        if (!reset && bookmark) qs += '&bookmark=' + encodeURIComponent(bookmark);
        return fetch(API + qs)
          .then(function(r){ if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
          .then(function(data){
            var list = data.results || [];
            bookmark = data.bookmark || null;
            if (!bookmark || !list.length) exhausted = true;
            if (reset) all = list; else all = all.concat(list);
            loading = false;
          })
          .catch(function(e){ loading = false; throw e; });
      }

      // The seeded pick survives only the very first search — the one that runs on
      // arrival with the same query the customer already searched in the store. Any
      // search they type after that starts clean.
      function doSearch(q, keepSelection){
        if (!q) return;
        if (!API){ gallery.hidden = false; grid.innerHTML = '<div class="fpp__error">' + I18N.notConfigured + '</div>'; return; }
        query = q; bookmark = null; exhausted = false;
        all = []; shown = 0;
        if (!keepSelection){
          selectedId = null; selectedUrl = null; seededPin = null;
          window.__fpiCart.selection = null;
        }
        gallery.hidden = false; setStatus('');
        setContext(q, null);
        showSkeletons();
        fetchPage(true)
          .then(function(){
            reconcileSeed();
            if (!all.length){ grid.innerHTML = ''; setContext(q, 0); setStatus('No images found. Try another search.'); moreBtn.hidden = true; return; }
            setContext(q, all.length);
            renderGrid();
          })
          .catch(function(){
            // A seeded pick is already on the product image and on the form, so a
            // failed search must not take it away — show it on its own.
            if (seededPin){
              all = [seededPin]; setContext(query, 1); renderGrid();
              setStatus("Couldn't load more images. Search again to see more.");
              return;
            }
            grid.innerHTML = ''; setContext(null); setStatus('Search failed. Please try again.');
          });
      }

      // The API's own object is richer than what fits in a URL (exact title,
      // dimensions), so prefer it when the seeded pin is on this page of results.
      // Otherwise keep the seed as the first tile, so the customer still sees the
      // image they picked, marked as selected.
      function reconcileSeed(){
        if (!seededPin) return;
        var found = null;
        for (var i = 0; i < all.length; i++){
          if (all[i].id && all[i].id === seededPin.id){ found = all[i]; break; }
        }
        if (found){
          seededPin = found;
          window.__fpiCart.selection = selectionFor(found);
          writeLineItemProps(found);
          // Only the first few tiles are on screen before "Show more", so the pin
          // has to lead — otherwise their own pick is the one image they can't see.
          var at = all.indexOf(found);
          if (at > 0){ all.splice(at, 1); all.unshift(found); }
        } else {
          all.unshift(seededPin);
        }
        selectedId = seededPin.id;
      }

      // p + k are all the API needs to hand back the same image at any size.
      function pinImage(p, size, k){
        return API + '/api/pin/image?p=' + encodeURIComponent(p) + '&s=' + size + '&k=' + encodeURIComponent(k);
      }
      // The framed render, which also needs the original's dimensions. Byte-identical
      // to the `framed` link the API returns, so a seeded pick doesn't reload the
      // image when the search catches up and hands us the real object.
      function pinFramed(p, k, w, h){
        if (!w || !h) return '';
        return pinImage(p, 'mid', k) + '&frame=1&w=' + w + '&h=' + h;
      }

      function renderGrid(){
        if (io) io.disconnect();
        grid.innerHTML = '';
        // Start at exactly INITIAL images; "Show more" grows this window by STEP.
        if (shown <= 0) shown = INITIAL;
        if (shown > all.length) shown = all.length;
        all.slice(0, shown).forEach(function(im){
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'fpp__thumb' + (im.id === selectedId ? ' is-selected' : '');
          var url = im.thumb || im.image;
          if (io){ b.setAttribute('data-bg', url); io.observe(b); }
          else b.style.backgroundImage = 'url("' + url + '")';
          b.setAttribute('aria-label', im.title || 'Image');
          b.setAttribute('aria-pressed', im.id === selectedId ? 'true' : 'false');
          var check = document.createElement('span');
          check.className = 'fpp__check'; check.setAttribute('aria-hidden', 'true'); check.textContent = '✓';
          b.appendChild(check);
          b.addEventListener('click', function(){ pick(im); });
          grid.appendChild(b);
        });
        setContext(query, all.length);
        updateMore();
      }

      function updateMore(){
        var remaining = all.length - shown;
        // Always on show, and never with a count: the number changed on every
        // click and read as a limit rather than an invitation. A click reveals
        // the next chunk of the buffer, or pulls another page when it runs out.
        moreBtn.hidden = false;
        moreBtn.textContent = 'Show more';
        // Nothing left anywhere — kept in place, greyed, so the row doesn't move.
        moreBtn.disabled = remaining <= 0 && exhausted;
        // Collapse is available once more than the initial 5 are on screen.
        if (lessBtn) lessBtn.hidden = shown <= INITIAL;
      }

      function pick(im){
        // The framed mid-quality render, so the product image shows what they'd
        // actually receive. The result tiles below stay unframed — the frame is
        // for the one image being previewed, not for browsing. Falls back to the
        // plain render for results served before the API returned `framed`.
        setProductImage(im.framed || im.image);
        window.__fpiCart.selection = selectionFor(im);
        writeLineItemProps(im);
        selectedId = im.id;
        renderGrid();
        // Fire-and-forget: tells the analytics dashboard which image was chosen.
        try { fetch(API + '/api/pin/select?p=' + encodeURIComponent(im.id) + '&title=' + encodeURIComponent(im.title || query), { keepalive: true }); } catch (e) {}
        var img = targetImg(root) || root;
        if (img && img.scrollIntoView) img.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      // Searching from here is this block's own search again — drop the query the
      // store search handed us.
      form.addEventListener('submit', function(e){
        e.preventDefault();
        sentOverride = null;
        doSearch(input.value.trim());
      });

      moreBtn.addEventListener('click', function(){
        if (shown < all.length){                       // Show more (N) — reveal buffered
          shown = Math.min(all.length, shown + STEP);
          renderGrid();
        } else if (!exhausted){                        // Show more — pull the next page
          moreBtn.disabled = true;
          moreBtn.textContent = 'Loading…';
          fetchPage(false)
            .then(function(){ shown = Math.min(all.length, shown + STEP); renderGrid(); })
            .catch(function(){ setStatus("Couldn't load more images."); updateMore(); });
        }
      });
      if (lessBtn) lessBtn.addEventListener('click', function(){
        shown = INITIAL;
        renderGrid();
        if (gallery.scrollIntoView) gallery.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });

      // Arriving from the home page's quick-custom search: run the query immediately.
      // Accepts the same ?fpi_q= the movie product uses, so a quick-custom tab can
      // point here without any change, plus ?fpp_q= for clarity.
      //
      // Arriving from the store's own search (assets/fm-poster-search.js) adds
      // ?fpp_p= and ?fpp_k= — the signed params of an image the customer already
      // picked there. Those rebuild the thumb/mid/hq links, so the pick is on the
      // product image and on the order the moment the page paints; the search below
      // only catches up afterwards.
      try {
        var params = new URLSearchParams(window.location.search);
        var preQuery = (params.get('fpp_q') || params.get('fpi_q') || '').trim();
        var pinP = params.get('fpp_p');
        var pinK = params.get('fpp_k');
        sentOverride = (params.get('fpp_s') || '').trim() || null;

        if (pinP && pinK && API) {
          query = preQuery;
          var pinW = parseInt(params.get('fpp_w'), 10) || 0;
          var pinH = parseInt(params.get('fpp_h'), 10) || 0;
          seededPin = {
            id: params.get('fpp_pin') || pinP,
            ref: pinP,
            title: params.get('fpp_t') || preQuery,
            width: pinW,
            height: pinH,
            thumb: pinImage(pinP, 'thumb', pinK),
            image: pinImage(pinP, 'mid', pinK),
            framed: pinFramed(pinP, pinK, pinW, pinH),
            hq: pinImage(pinP, 'hq', pinK)
          };
          selectedId = seededPin.id;
          window.__fpiCart.selection = selectionFor(seededPin);
          writeLineItemProps(seededPin);
          // The theme's media gallery may not be in the DOM yet on a cold load.
          var seededPreview = seededPin.framed || seededPin.image;
          if (!setProductImage(seededPreview)) {
            setTimeout(function () { setProductImage(seededPreview); }, 400);
          }
        }

        if (preQuery) {
          input.value = preQuery;
          doSearch(preQuery, !!seededPin);
          // Land the visitor on the search + results, not the top of the page —
          // only for a plain search (home quick-custom). Arriving with an image
          // already picked, the product image is the thing worth landing on.
          if (!seededPin) {
            setTimeout(function () {
              if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 450);
          }
        }
      } catch (e) { /* older browsers: no prefill */ }
    }

    function initAll(){ document.querySelectorAll('[data-fpp]').forEach(init); }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-image-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var TARGET_FALLBACKS = [
      '[data-fpi-target] img', '[data-fpi-target]',
      '.product-media-container img', 'product-media-gallery img',
      '.product__media img', '.product-media img', '.product__media-item img'
    ];

    function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

    function targetImg(root){
      var sel = root.getAttribute('data-target');
      var list = (sel ? [sel] : []).concat(TARGET_FALLBACKS);
      for (var i = 0; i < list.length; i++){
        var el = null;
        try { el = document.querySelector(list[i]); } catch (e) {}
        if (el) return el;
      }
      return null;
    }

    // The /cart/add fetch override is installed by the early inline <script> at the
    // top of this block. Here we just publish the current pick's line item
    // properties to that shared global for the override to read.
    window.__fpiCart = window.__fpiCart || { selection: null };

    function init(root){
      /* Liquid is not rendered inside a block's javascript tag, so these ride
         in as data attributes on the root element, which is rendered. */
      var I18N = {
        tapHint: root.getAttribute('data-i18n-tap-hint') || '',
        notConfigured: root.getAttribute('data-i18n-not-configured') || '',
        searching: root.getAttribute('data-i18n-searching') || '',
        searchFailed: root.getAttribute('data-i18n-search-failed') || '',
        noMatches: root.getAttribute('data-i18n-no-matches') || '',
        untitled: root.getAttribute('data-i18n-untitled') || '',
        loadFailed: root.getAttribute('data-i18n-load-failed') || '',
        showMore: root.getAttribute('data-i18n-show-more') || '',
      };
      if (root.hasAttribute('data-fpi-init')) return;
      root.setAttribute('data-fpi-init', '1');

      var API = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
      var GENRE = (root.getAttribute('data-genre') || '').trim();  // '' = all, 'animation' = filter
      var searchbox = root.querySelector('.fpi__searchbox');
      var form = root.querySelector('[data-form]');
      var input = root.querySelector('[data-input]');
      var results = root.querySelector('[data-results]');
      var gallery = root.querySelector('[data-gallery]');
      var grid = root.querySelector('[data-grid]');
      var moreBtn = root.querySelector('[data-more]');
      var lessBtn = root.querySelector('[data-less]');
      var status = root.querySelector('[data-status]');
      var context = root.querySelector('[data-context]');

      var all = [], shown = 0, overlay = null, currentItem = null;
      var selectedId = null;
      var selectedUrl = null, watching = false, watchTimer = null;
      var STEP = 10;   // "Show more" reveals this many additional posters per click

      // Lazy-load poster backgrounds as tiles scroll into the gallery. This replaces
      // content-visibility (which stacked tiles on mobile), so the grid stays a plain,
      // reliable CSS grid on every device while still not fetching 300 images at once.
      var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          var t = e.target, u = t.getAttribute('data-bg');
          if (u){ t.style.backgroundImage = 'url("' + u + '")'; t.removeAttribute('data-bg'); }
          io.unobserve(t);
        });
      }, { root: grid, rootMargin: '400px 0px' }) : null;

      function setStatus(m){ status.hidden = !m; status.textContent = m || ''; }

      function typeLabel(t){ return t === 'tv' ? 'TV series' : t === 'person' ? 'Person' : 'Movie'; }
      function setContext(item, count){
        if (!item){ context.hidden = true; context.textContent = ''; return; }
        context.hidden = false;
        context.innerHTML =
          '<div class="fpi__ctx-main"><span class="fpi__ctx-title"></span><span class="fpi__ctx-count"></span></div>' +
          '<div class="fpi__ctx-hint">' + I18N.tapHint + '</div>';
        context.querySelector('.fpi__ctx-title').textContent = item.title || '';
        context.querySelector('.fpi__ctx-count').textContent =
          (count == null) ? 'Loading…' : (count + (count === 1 ? ' poster' : ' posters'));
      }
      function showSkeletons(){
        grid.innerHTML = '';
        var n = Math.max(colsPerRow(), 4);
        for (var i = 0; i < n; i++){ var s = document.createElement('div'); s.className = 'fpi__thumb fpi__skel'; grid.appendChild(s); }
        moreBtn.hidden = true;
        if (lessBtn) lessBtn.hidden = true;
      }

      function productLoading(on){
        var img = targetImg(root);
        if (!img) return;
        var host = img.parentElement || img;
        if (on){
          if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
          if (!overlay){ overlay = document.createElement('div'); overlay.className = 'fpi__overlay'; overlay.innerHTML = '<span class="fpi__spin"></span>'; }
          host.appendChild(overlay);
        } else if (overlay && overlay.parentNode){
          overlay.parentNode.removeChild(overlay);
        }
      }

      // Re-apply the picked poster if the theme swaps the product media back (it does
      // this on variant change), so the selection sticks across size/variant changes.
      function reapplySelected(){
        if (!selectedUrl) return;
        var img = targetImg(root);
        if (img && img.getAttribute('src') !== selectedUrl){
          img.removeAttribute('srcset');
          img.setAttribute('src', selectedUrl);
        }
      }
      function ensureMediaWatch(){
        if (watching) return;
        var img = targetImg(root);
        if (!img) return;
        var container = img.closest('.shopify-section, .product, product-info, main') || img.parentElement;
        if (!container) return;
        watching = true;
        var mo = new MutationObserver(function(){
          if (!selectedUrl) return;
          clearTimeout(watchTimer);
          watchTimer = setTimeout(reapplySelected, 60);
        });
        mo.observe(container, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
        var form = productForm();
        if (form) form.addEventListener('change', function(){ clearTimeout(watchTimer); watchTimer = setTimeout(reapplySelected, 150); });
      }

      function setProductImage(url){
        var img = targetImg(root);
        if (!img) return false;
        selectedUrl = url;
        ensureMediaWatch();
        img.removeAttribute('srcset');
        // Already showing this exact image -> nothing to load.
        if (img.getAttribute('src') === url && img.complete) return true;
        // Show the spinner until the newly selected image finishes loading
        // (the watermarked image is generated server-side, so it takes a moment).
        productLoading(true);
        var done = function(){
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          productLoading(false);
        };
        img.addEventListener('load', done);
        img.addEventListener('error', done);
        img.setAttribute('src', url);
        return true;
      }

      // Attach the selection to the ordered product via line item properties.
      // Names start with "_" so they're hidden from the customer in cart/checkout
      // but still recorded on the order (visible in the Shopify admin).
      function productForm(){
        var scope = root.closest('.shopify-section, product-form, .product') || document;
        return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      }
      function setProp(form, key, value){
        var input = form.querySelector('input[data-fpi-prop="' + key + '"]');
        if (!input){
          input = document.createElement('input');
          input.type = 'hidden';
          input.setAttribute('data-fpi-prop', key);
          input.name = 'properties[' + key + ']';
          form.appendChild(input);
        }
        input.value = value == null ? '' : value;
      }
      function writeLineItemProps(im){
        var form = productForm();
        if (!form || !currentItem) return;
        setProp(form, '_Title', currentItem.title || '');
        setProp(form, '_Type', currentItem.media_type || '');   // movie / tv / person
        setProp(form, '_Media ID', currentItem.id || '');       // TMDB id of the movie/series
        setProp(form, '_Image ID', im.id || '');                // TMDB id of the chosen image
        setProp(form, '_Image URL', im.url || im.thumb || '');  // clickable watermarked image
      }

      function doSearch(q){
        if (!q) return;
        if (!API){ results.hidden = false; results.innerHTML = '<div class="fpi__error">' + I18N.notConfigured + '</div>'; return; }
        results.hidden = false; results.innerHTML = '<div class="fpi__muted">' + I18N.searching + '</div>';
        gallery.hidden = true; setStatus('');
        // On the animation product GENRE is 'animation', so the API only returns
        // titles in that genre; on the movies/series product it's '' (all results).
        var qs = '/api/search?query=' + encodeURIComponent(q) + (GENRE ? '&genre=' + encodeURIComponent(GENRE) : '');
        fetch(API + qs)
          .then(function(r){ if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
          .then(function(data){ renderResults(data.results || []); })
          .catch(function(){ results.innerHTML = '<div class="fpi__error">' + I18N.searchFailed + '</div>'; });
      }

      function renderResults(list){
        results.innerHTML = '';
        if (!list.length){ results.innerHTML = '<div class="fpi__empty">' + I18N.noMatches + '</div>'; return; }
        list.forEach(function(item){
          var el = document.createElement('button');
          el.type = 'button'; el.className = 'fpi__result'; el.setAttribute('role', 'option');
          var poster = document.createElement('span');
          poster.className = 'fpi__result-poster';
          if (item.image) poster.style.backgroundImage = 'url("' + item.image + '")';
          var body = document.createElement('span'); body.className = 'fpi__result-body';
          var title = document.createElement('span'); title.className = 'fpi__result-title'; title.textContent = item.title || I18N.untitled;
          var type = document.createElement('span'); type.className = 'fpi__result-type'; type.textContent = typeLabel(item.media_type);
          body.appendChild(title); body.appendChild(type);
          el.appendChild(poster); el.appendChild(body);
          el.addEventListener('click', function(){ selectItem(item); });
          results.appendChild(el);
        });
      }

      function selectItem(item){
        currentItem = item;
        results.hidden = true;
        gallery.hidden = false;
        shown = 0; all = []; selectedId = null; selectedUrl = null; window.__fpiCart.selection = null; setStatus('');
        setContext(item, null);
        showSkeletons();
        productLoading(true);
        // GENRE rides along so the analytics dashboard can tell an Animation-product
        // open apart from a Movies & series one (it never changes what's returned).
        fetch(API + '/api/images?type=' + encodeURIComponent(item.media_type) + '&id=' + encodeURIComponent(item.id) + (GENRE ? '&genre=' + encodeURIComponent(GENRE) : ''))
          .then(function(r){ if (!r.ok) throw new Error('images ' + r.status); return r.json(); })
          .then(function(data){
            productLoading(false);
            all = data.images || [];
            if (!all.length){ grid.innerHTML = ''; setContext(item, 0); setStatus('No posters found for this title.'); return; }
            setContext(item, all.length);
            renderGrid();
          })
          .catch(function(){ productLoading(false); grid.innerHTML = ''; setStatus(I18N.loadFailed); });
      }

      // Columns the grid currently shows, from the resolved auto-fill tracks — so the
      // collapsed view fills exactly one row for the screen size (responsive), not a
      // fixed 3.
      function colsPerRow(){
        try{
          var t = getComputedStyle(grid).gridTemplateColumns;
          var n = t.split(/\s+/).filter(function(s){ return s && s !== 'none'; }).length;
          return n > 0 ? n : 3;
        }catch(e){ return 3; }
      }

      function renderGrid(){
        if (io) io.disconnect();
        grid.innerHTML = '';
        var perRow = colsPerRow();
        // Start collapsed at exactly one row; "Show more" grows this window by STEP.
        if (shown <= 0) shown = perRow;
        if (shown > all.length) shown = all.length;
        var list = all.slice(0, shown);
        list.forEach(function(im){
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'fpi__thumb' + (im.id === selectedId ? ' is-selected' : '');
          var url = im.thumb || im.url;
          if (io){ b.setAttribute('data-bg', url); io.observe(b); }
          else b.style.backgroundImage = 'url("' + url + '")';
          b.setAttribute('aria-label', 'Poster' + (im.language ? ' (' + im.language + ')' : ''));
          b.setAttribute('aria-pressed', im.id === selectedId ? 'true' : 'false');
          var check = document.createElement('span');
          check.className = 'fpi__check'; check.setAttribute('aria-hidden', 'true'); check.textContent = '✓';
          b.appendChild(check);
          b.addEventListener('click', function(){ pick(im); });
          grid.appendChild(b);
        });
        var remaining = all.length - shown;
        if (remaining > 0){
          // Reveal the next chunk — the count is the min of STEP and what's left.
          moreBtn.hidden = false;
          moreBtn.textContent = I18N.showMore.replace('__N__', Math.min(STEP, remaining));
        } else {
          moreBtn.hidden = true;
        }
        // Collapse is available whenever more than one row is on screen.
        if (lessBtn) lessBtn.hidden = shown <= perRow;
      }

      function pick(im){
        // Product image = the poster inside a frame sized to its aspect (no crop/stretch).
        var framed = im.url
          ? (im.url + '&frame=1' + (im.width && im.height ? ('&w=' + im.width + '&h=' + im.height) : ''))
          : (im.thumb || '');
        setProductImage(framed);
        window.__fpiCart.selection = {
          '_Title': (currentItem && currentItem.title) || '',
          '_Type': (currentItem && currentItem.media_type) || '',
          '_Media ID': (currentItem && currentItem.id) || '',
          '_Image ID': im.id || '',
          '_Image URL': im.url || im.thumb || ''
        };
        writeLineItemProps(im);
        selectedId = im.id;
        // Keep the current window (the picked tile is already visible) and just
        // re-render to move the selected highlight.
        renderGrid();
        // Scroll up so the customer sees the product image update.
        var img = targetImg(root) || root;
        if (img && img.scrollIntoView) img.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      form.addEventListener('submit', function(e){ e.preventDefault(); doSearch(input.value.trim()); });
      moreBtn.addEventListener('click', function(){
        shown = Math.min(all.length, shown + STEP);
        renderGrid();
      });
      if (lessBtn) lessBtn.addEventListener('click', function(){
        shown = colsPerRow();
        renderGrid();
        if (gallery.scrollIntoView) gallery.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });

      // Close the results dropdown when clicking outside the search box.
      document.addEventListener('click', function(e){
        if (searchbox && !searchbox.contains(e.target)) results.hidden = true;
      });

      // Arriving from the home page's quick-custom search: run the query
      // immediately (?fpi_q=...).
      try {
        var preQuery = new URLSearchParams(window.location.search).get('fpi_q');
        if (preQuery && preQuery.trim()) {
          input.value = preQuery.trim();
          doSearch(preQuery.trim());
          // Land the visitor on the search + results, not the top of the page
          setTimeout(function () {
            if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 450);
        }
      } catch (e) { /* older browsers: no prefill */ }
    }

    function initAll(){ document.querySelectorAll('[data-fpi]').forEach(init); }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
